<template>
  <modal
    :show-close="true"
    @close="$emit('close')"
  >
    <section v-if="error" slot="error" class="error">
      {{ error }}
    </section>
    <section slot="header">
      delete this impact report
    </section>
    <section slot="body">
      are you sure you want to delete this impact report?
    </section>
    <section slot="action" class="action-wrapper">
      <button class="button secondary" @click="$emit('close')">back</button>
      <button class="button" @click="deleteReport">delete</button>
    </section>
  </modal>
</template>

<script>
import Modal from '../../../components/shared/Modal';
import { reportsAPI } from "../../../services/api/reportsAPI";

export default {
  name: "DeleteReportModal",
  props: {
    reportId: Number,
  },
  components: {
    Modal,
  },
  data: () => ({
    error: null,
  }),
  methods: {
    deleteReport() {
      try {
        reportsAPI.deleteReport(this.reportId);
        this.$router.push("/reports/impact");
      } catch (e) {
        this.error = "Unable to delete the report. Contact support for help.";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
section {
  font-size: x-large;
  margin: 25px 0;
  max-width: 350px;
}

.action-wrapper {
  display: flex;
  justify-content: center;
  gap: 30px;
}

.button {
  min-width: 90px;
}
</style>
